import { usePlatform } from '@hellodarwin/core/lib/features/providers/platform-provider';
import { useMemo } from 'react';
import { AssistantMessageFormatter } from '../../services/AssistantMessageFormatter';
import { ToolOutcome } from '../../types/tool.types';
import { deriveToolStatus, isAgentControlTool, useToolState, } from '../../utils/sseEventUtils';
import { getDefaultExpanded, getDefaultExpandedSections, getToolDisplayVariant, getToolLabelKey, isToolExpandable, } from './tool-card-config';
export const useToolCardModel = (message) => {
    const { app } = usePlatform();
    const toolState = useToolState(message);
    return useMemo(() => {
        const tool = toolState.toolCall;
        if (!tool || isAgentControlTool(tool.function.name)) {
            return null;
        }
        const status = deriveToolStatus(toolState);
        const displayVariant = getToolDisplayVariant(tool.function.name);
        const toolCallUI = Object.assign(Object.assign({}, tool), { message_uuid: message.id, outcome: toolState.isError
                ? ToolOutcome.FAILURE
                : toolState.isCompleted
                    ? ToolOutcome.SUCCESS
                    : undefined, progress: toolState.progress, result: toolState.result, error: toolState.isError ? 'Error occurred' : undefined, isExpanded: false, started_at: toolState.startedAt, finished_at: toolState.finishedAt });
        return {
            app,
            toolName: tool.function.name,
            tool: toolCallUI,
            status,
            displayVariant,
            labelKey: getToolLabelKey(tool.function.name),
            executionTime: AssistantMessageFormatter.formatExecutionTime(toolCallUI),
            errorText: toolCallUI.error,
            isExpandable: isToolExpandable(app, displayVariant),
            defaultExpanded: getDefaultExpanded(app, displayVariant),
            defaultExpandedSections: getDefaultExpandedSections(status),
        };
    }, [app, message.id, toolState]);
};
